import { DataFetchingThunkAction, BellaThunkDispatch } from '../../redux/types';
import { FetchActionManager } from './FetchManagerContext';

export default class ClientFetchActionManager implements FetchActionManager {
    public dispatchFetchingAction = (thunkAction: DataFetchingThunkAction, dispatch: BellaThunkDispatch) => {
        dispatch(thunkAction);
    };
}
